import { useIsFs } from '@src/application/modules/flagship/hooks/fsHooks';
import { EventNotificationProps } from '@application/modules/shared/type';
import { EventNotification as FsEventNotification } from '@application/modules/flagship/components/Header/EventNotification/EventNotification';
import { EventNotification as TagEventNotification } from '@application/modules/tag/Header/EventNotification/EventNotification';

export const AB_TASTY_QA_ASSISTANT_NOTIFICATION = 'AB_TASTY_QA_ASSISTANT_NOTIFICATION' as const;
export const EVENT_NOTIFICATION_TEST_ID = 'event-notification' as const;

export const EventNotification = ({ activeTab }: EventNotificationProps) => {
  const hasFsEnvId = useIsFs();
  const Component = hasFsEnvId ? FsEventNotification : TagEventNotification;
  return <Component activeTab={activeTab} />;
};
